/**
 * Regla ÚNICA de visibilidad de canchas para participantes (modelo GLOBAL-ONLY).
 *
 * Existe una sola fuente de verdad: `_meta.hideCourtsFromParticipants` en el
 * `schedule_data` del torneo (lo escribe el switch "Mostrar canchas a participantes"
 * del organizador).
 *   - true  = ocultar TODAS las canchas preasignadas → el participante ve "Por definir".
 *   - false = mostrar las canchas.
 *
 * NO hay control por-cancha. Cualquier `courtHidden` por-bloque/partido que haya
 * quedado en datos viejos se IGNORA (primer parámetro), para que todas las vistas
 * del player den exactamente el mismo resultado.
 *
 * (Se conserva la firma `(perCourtValue, globalHidden)` para no tocar los llamadores;
 * el primer argumento se ignora a propósito.)
 */
export const effectiveCourtHidden = (
  _perCourtValue: unknown,
  globalHidden: boolean
): boolean => globalHidden === true;
